import uuid from '../../../services/uuid';

export const saveState = (redirectUrl?: string, state?: string) => {
  sessionStorage.removeItem('redirectUrl');
  sessionStorage.removeItem('state');

  sessionStorage.setItem('state', state !== undefined ? state : uuid.generate());
  if (redirectUrl) {
    sessionStorage.setItem('redirectUrl', redirectUrl);
  }
};
